import TopUpDetails from "../ProviderDetails";
import Product from "../PlanLists";
import { ExternalContainer } from "../../../components/Account/reusables";
import { Header } from "../Header";

const DirectTopUp = () => {
  return (
    <div className="h-full  w-[full]  md:px-8 lg:px-[56px]">
      <ExternalContainer>
        <div>
          <Header />
          <div className="flex flex-col bp:flex-row items-start gap-12">
            <TopUpDetails />
            <Product productType="topup" />
          </div>
        </div>
      </ExternalContainer>
    </div>
  );
};

export default DirectTopUp;
